<!--
  File name: NotificationType.vue
  Program Description:
    - This component contains the design for the Notification Type export function
    - When accessed, it renders the values passed from the parent component and
    assigns the values to be passed on the child component (FormRow)
  Includes:
    * FormRow
    * helpers method
-->

<template>
  <v-container>
    <v-row class="pa-0 ma-0 padd">
      <h2
        class="font primary marginBot"
        style="font-size: 20px;"
      >
        Assigned to
      </h2>
    </v-row>
    <v-row class="header">
      <v-col cols="6">
        <FormRow
          :fields="[
            {
              label: 'Evaluator',
              value: assignedTo.evaluator
            }
          ]"
        />
        <FormRow
          :fields="[
            {
              label: 'First Reviewer',
              value: assignedTo.firstPass
            }
          ]"
        />
        <FormRow
          :fields="[
            {
              label: 'Final Reviewer',
              value: assignedTo.final
            }
          ]"
        />
      </v-col>
    </v-row>
    <FormRow
      :fields="[
        {
          label: 'PDBNF Status',
          value: notif.status
        },
        {
          label: 'DBN Number',
          value: notif.dbnNumber
        }
      ]"
    />
    <FormRow
      :fields="[
        {
          label: 'Name of PIC',
          value: notif.fullName
        },
        {
          label: 'Email Address',
          value: notif.email
        }
      ]"
    />
    <FormRow
      :fields="[
        {
          label: 'Representative',
          value: notif.representative
        },
        {
          label: 'Email Address',
          value: notif.contactInfo
        }
      ]"
    />
    <FormRow
      :fields="[
        {
          label: 'Date of Occurence',
          value: notif.dateOfOccurrence
        },
        {
          label: 'Date of Discovery',
          value: notif.dateOfDiscovery
        }
      ]"
    />
    <FormRow
      :fields="[
        {
          label: 'Date of Notification',
          value: notif.dateOfNotification
        },
        {
          label: 'Date of Evaluation',
          value: notif.dateOfEvaluation
        }
      ]"
    />
    <v-row class="pa-0 ma-0 padd">
      <h2
        class="font primary"
        style="font-size: 20px; margin-top: 25px"
      >
        Notification Type
      </h2>
    </v-row>
    <v-row
      v-for="(type, idx) in notif.notifications"
      :key="idx"
      class="font size padd"
    >
      <v-col v-if="type">
        <v-row style="margin-top: 5px; margin-bottom: 5px">
          <v-icon
            v-if="type.checkbox"
            small
            color="black"
            style="margin-right: 5px"
          >
            mdi-check
          </v-icon>
          <p>
            {{ type.name }}
          </p>
        </v-row>
        <v-row class="pa-0 ma-0">
          <v-col
            cols="3"
            style="border: 0.1px solid #454545; border-right: none"
          >
            {{ type.subtype }}
          </v-col>
          <v-col
            cols="9"
            style="border: 0.1px solid #454545"
          >
            Remarks: {{ type.remarks }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FormRow from './FormRow.vue'
import { toDateString } from '@/utils/helpers'

export default {
  components: {
    FormRow
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  computed: {
    notif () {
      if (!this.$props.data) return {}

      const { status, dateOfOccurrence, dateOfDiscovery, dateOfNotification, dateOfEvaluation } = this.$props.data
      return {
        ...this.$props.data,
        status: status.value,
        dateOfOccurrence: (!dateOfOccurrence || dateOfOccurrence === '') ? '' : toDateString(dateOfOccurrence),
        dateOfDiscovery: (!dateOfDiscovery || dateOfDiscovery === '') ? '' : toDateString(dateOfDiscovery),
        dateOfNotification: (!dateOfNotification || dateOfNotification === '') ? '' : toDateString(dateOfNotification),
        dateOfEvaluation: (!dateOfEvaluation || dateOfEvaluation === '') ? '' : toDateString(dateOfEvaluation)
      }
    },
    assignedTo () {
      const { evaluator, final, firstPass } = this.$props.data.assignedTo
      return {
        evaluator: evaluator.fullName,
        final: final.fullName,
        firstPass: firstPass.fullName
      }
    }
  }
}
</script>

<style scoped>
  .header {
    border-bottom: 1px solid black;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .font {
    font-family: 'Source Sans Pro';
  }
  .primary {
    color: #383c74
  }
  .padd {
    padding-left: 3px;
  }
  .size {
    font-size: 13px;
  }
  .marginBot {
    margin: 0px 0px 10px 0px;
  }
</style>
